import useTheme from 'hooks/useTheme'

interface OrdnatLogoProps {
    className?: string
}

const OrdnatLogo = ({ className }: OrdnatLogoProps) => {
    const { resolved } = useTheme()
    const src = resolved === 'dark' ? '/img/logo/Ordnat_logo_white.png' : '/img/logo/Ordnat_logo.png'

    return <img src={src} alt="Ordnat Logo" className={className} />
}

export default OrdnatLogo
